export function AskNowCarousel(props: any) {
  const handleClick = () => {
    window.open("https://asknow.service-now.com/asknow/", "_blank", "noreferrer");
  };
  return (
    <div className="card border-0 mb-0 pb-0" onClick={handleClick} style={{ cursor: "pointer" }}>
      <img src={props.web_url} className="w-100 img-fluid desktopImage" alt="ASKNow" />
      <img
        src={props.mobile_url}
        className="w-100 img-fluid mobileImage"
        alt="ASKNow"
      />
      <div className="card-img-overlay text-start">
        <div className="row mt-0 mt-md-4">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12">
                <h2 className="text-end me-5 pe-4 desktopTextWhite">
                  Is technology playing tricks on you?
                </h2>
              </div>
            </div>

            <div className="row position-absolute bottom-0 end-0 mb-0 me-2 ms-2 mb-md-3 me-md-4 desktopTextWhite">
              <div className="col-md-12">
                <p className="text-end pe-4">
                  Visit{" "}
                  <a
                    href="https://asknow.service-now.com/asknow/"
                    target={"_blank"}
                    rel="noreferrer"
                  >
                    ASKNow
                  </a>{" "}
                  ,TTEC's IT support Service Desk.
                  <br /> Here, you'll find instructions on how to access tools
                  and <br />
                  troubleshooting tips that will help you solve your issue
                  quickly.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
